import { CUSTOMER_LOGIN_SLUG } from '../routes'
import { buildAuthLink } from '../helpers/formatters'
import { useShopI18n } from '../../i18n'

type CustomerAccessRequiredPageProps = {
  requestedAccountPath: string
}

export const CustomerAccessRequiredPage = ({
  requestedAccountPath,
}: CustomerAccessRequiredPageProps) => {
  const { t, toLocalizedPath } = useShopI18n()
  const trustItems = [
    t('customer.accessRequired.trust.orders'),
    t('customer.accessRequired.trust.tracking'),
    t('customer.accessRequired.trust.support'),
  ]

  return (
    <div className="ca-page ca-theme-transition px-4 sm:px-6 lg:px-8">
      <section className="mx-auto w-full max-w-md pt-16 pb-10 sm:pt-20 sm:pb-12">
        <div className="ca-card-shell ca-theme-transition w-full rounded-2xl border border-(--color-border-default) bg-(--color-bg-card) px-5 py-5 shadow-[0_16px_36px_-20px_color-mix(in_srgb,var(--color-text-primary)_22%,transparent)] sm:px-6 sm:py-6">
          <div className="space-y-4.5">
            <div className="space-y-2.5 text-center">
              <span className="ca-badge-info mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full border border-(--color-status-info-border) bg-[color-mix(in_srgb,var(--color-status-info-bg)_85%,var(--color-bg-card))]">
                <svg viewBox="0 0 24 24" className="h-5.5 w-5.5 fill-none stroke-current stroke-[1.9]" aria-hidden>
                  <rect x="5" y="11" width="14" height="10" rx="2" />
                  <path d="M8 11V8a4 4 0 1 1 8 0v3" />
                </svg>
              </span>
              <h1 className="text-balance text-3xl font-bold tracking-tight text-(--color-text-primary)">
                {t('customer.accessRequired.contextTitle')}
              </h1>
              <p className="mx-auto max-w-[44ch] text-sm leading-relaxed text-(--color-text-secondary)">
                {t('customer.accessRequired.contextDescription')}
              </p>
            </div>

            <a
              href={buildAuthLink(CUSTOMER_LOGIN_SLUG, requestedAccountPath, toLocalizedPath)}
              className="ca-btn-primary inline-flex h-11 w-full items-center justify-center rounded-xl px-4 text-sm font-semibold shadow-[0_10px_24px_-16px_color-mix(in_srgb,var(--color-action-primary)_55%,transparent)] transition duration-150 hover:brightness-110 hover:scale-[1.01] active:scale-[0.99]"
            >
              {t('common.goToLogin')}
            </a>

            <div className="border-t border-(--color-border-subtle) pt-3">
              <ul className="grid gap-2.5">
                {trustItems.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="ca-badge-info inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-(--color-status-info-border)">
                      <svg viewBox="0 0 16 16" className="h-3 w-3 fill-none stroke-current stroke-[2]" aria-hidden>
                        <path d="M3.2 8.2 6.3 11l6.5-6.2" />
                      </svg>
                    </span>
                    <span className="text-sm font-semibold text-(--color-text-secondary)">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
